import { render, staticRenderFns } from "./LoanApproval.vue?vue&type=template&id=fba3a84c&scoped=true"
import script from "./LoanApproval.vue?vue&type=script&lang=js"
export * from "./LoanApproval.vue?vue&type=script&lang=js"
import style0 from "./LoanApproval.vue?vue&type=style&index=0&id=fba3a84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba3a84c",
  null
  
)

export default component.exports